<template>
    <div id="page">
    <div class="page-content">
        <div data-height="cover" class="caption bottom-0">
            <div class="cap-center">
                <div class="left-50 right-50 top-50">
                    <h1 class="center-text uppercase ultrabold fa-3x">LOGIN</h1>
                    <p class="center-text font-11 under-heading bottom-30 color-highlight">
                        Let's get you logged in
                    </p>
                    <LoginForm />
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm'

export default {
  name: 'Login',
  components: {
      LoginForm
  }
}
</script>

<style>
.cap-center{
    margin: auto;
    max-width: 500px;
    }
</style>